/**
 * Reads a response body as JSON, or null when the body is not valid JSON. The
 * callers check the value with a schema, so a broken body becomes the same
 * "unexpected body" answer as any other wrong shape instead of a thrown error.
 *
 * @param response - The response whose body to read.
 * @returns The parsed body, or null when it does not parse.
 */
export const readJson = async (response: Response): Promise<unknown> => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};
